import React from "react";
import { Text } from "ui-components";

import {
  RiskSectionInfoWrapper,
  RiskSectionInfoHeader,
  RiskSectionInfoContent
} from "./styled";

/**
 * Summarize the count of checked suggested controls from the user-added list
 * @param  {array}  suggestedTips List of custom suggested tips
 * @return {string}               Summary count of custom checked suggested controls
 */
const getSuggestedTipsInfo = suggestedTips => {
  // Get all checked tips from the list of custom suggested tips
  const customSuggestedTips = suggestedTips.filter(tip => tip.isChecked);

  // Get the count of all checked suggested tips added in a section and pluralize it
  const suggestedTipsCount = customSuggestedTips.length;
  const pluralize = suggestedTipsCount > 1 ? "s" : "";

  return suggestedTipsCount > 0
    ? `${suggestedTipsCount} new Suggested Control${pluralize} added`
    : "";
};

/**
 * Summarize the count of selected tips from all appendix sections
 * @param  {object} section Current section with list of checked appendix tips
 * @return {string}         Summary count of checked appendix tips
 */
const getAppendixTipsInfo = checkedAppendixTips => {
  // Get the list of checked appendix tips for the section
  const selectedAppendixKeys = checkedAppendixTips
    ? Object.keys(checkedAppendixTips)
    : false;

  let selectedSectionCounts = [];

  if (selectedAppendixKeys) {
    selectedSectionCounts = selectedAppendixKeys.sort().reduce((accum, key) => {
      // Concatenate all appendix subsection arrays for proper selection counting
      const mergedTips = [].concat.apply([], checkedAppendixTips[key]);
      const sectionLength = mergedTips.length;

      const pluralize = sectionLength > 1 ? "s" : "";

      // Add the appendix section count to the list if any tips were selected
      return sectionLength > 0
        ? accum.concat(
            `${sectionLength} tip${pluralize} from ${key.toUpperCase()}`
          )
        : accum;
    }, selectedSectionCounts);
  }

  return selectedSectionCounts.join(" / ");
};

const RiskSectionInfo = ({ suggestedTips, checkedAppendixTips }) => {
  const suggestedTipsInfo = getSuggestedTipsInfo(suggestedTips);
  const appendixTipsInfo = getAppendixTipsInfo(checkedAppendixTips);

  // Don't display an empty RiskSectionInfo component
  if (suggestedTipsInfo === "" && appendixTipsInfo === "") {
    return null;
  }

  return (
    <RiskSectionInfoWrapper>
      <RiskSectionInfoHeader>
        <Text type="bold" size="4">
          Risk Specific Guidelines and Tips
        </Text>
      </RiskSectionInfoHeader>
      <RiskSectionInfoContent>
        <Text size="5">{suggestedTipsInfo}</Text>
        <Text size="5">{appendixTipsInfo}</Text>
      </RiskSectionInfoContent>
    </RiskSectionInfoWrapper>
  );
};

export default RiskSectionInfo;



// WEBPACK FOOTER //
// ./src/common/components/RiskSectionInfo/RiskSectionInfo.jsx